import React from "react";
import { Route, Switch, Redirect } from "react-router";
import "./HomeStyles.scss";
import "../SignIn/SignInStyles.scss";
// Design-system reskin of all auth surfaces (scoped under .home-wrapper, imported
// last so it layers over the legacy styles). Touches no form/auth logic.
import "./auth-theme.scss";
import { getLocalStorage, getValidLandingScreen } from "../../helpers/utils";
import { FlickeringGrid } from "../../components/ds";
import AppLogo from "../../assets/images/app-logo.png";

import { useHistory } from "react-router-dom";
import LazyLoad from "../../components/Common/LazyLoad";

const SignIn = LazyLoad(() => import("../SignIn/component"));
const MagicLinkSentPage = LazyLoad(() => import("../SignIn/MagicLinkSentPage"));
const VerifyMagicLink = LazyLoad(() => import("../SignIn/VerifyMagicLink"));
const ForgotPassword = LazyLoad(() =>
  import("../SignIn/ForgotPassword/component")
);
const ResetPassword = LazyLoad(() =>
  import("../SignIn/ResetPassword/component")
);

export default function Home() {
  const history = useHistory();
  if (getLocalStorage("AUTH_DETAILS")) {
    return <Redirect to={getValidLandingScreen()} />;
  }
  return (
    <div className="home-wrapper auth-shell">
      <aside className="signup-wrapper auth-hero">
        <FlickeringGrid
          className="signup-flicker"
          squareSize={4}
          gridGap={6}
          flickerChance={0.3}
          maxOpacity={0.4}
          color="rgb(120, 170, 255)"
        />
        <img
          src={AppLogo}
          className="app-logo"
          alt="CYBRBASE XRM"
          onClick={() => history.push("/sign-in")}
        />
        <div className="signup-subcontainer">
          <p className="auth-eyebrow">CYBRBASE XRM</p>
          <h1 className="welcome-text">
            Your Cyber Resilience
            <br />
            Operating System.
          </h1>
          <p className="auth-hero-copy">
            Manage assessments, risk, remediation, policies, governance and
            incident readiness in one secure workspace.
          </p>
          <ul className="auth-hero-points auth-hero-pillars">
            <li>Assessments</li>
            <li>Risk &amp; Remediation</li>
            <li>Policies &amp; Governance</li>
            <li>IR Playbooks</li>
          </ul>
        </div>
      </aside>
      <div className="form-wrapper auth-panel">
        <Switch>
          <Route path="/sign-in" component={SignIn} />
          <Route path="/sign-up" component={SignIn} />
          {/* SignUp component is disabled, so redirecting to SignIn */}
          <Route path="/magic-link-sent" component={MagicLinkSentPage} />
          <Route path="/verify-token" component={VerifyMagicLink} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/password-reset/:token" component={ResetPassword} />
        </Switch>
      </div>
    </div>
  );
}
